import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-lg-font-select',
  templateUrl: './font-select.component.html',
  styleUrls: ['./font-select.component.scss']
})
export class FontSelectComponent implements OnInit {
  @Input() control: FormControl;
  public fonts: { id: number; name: string }[];

  constructor() {}

  ngOnInit() {
    this.fonts = [
      { id: 1, name: 'Roboto' },
      { id: 2, name: 'Lato' },
      { id: 3, name: 'Open Sans' },
      { id: 4, name: 'Oswald' },
      { id: 5, name: 'PT Sans' },
      { id: 6, name: 'Dosis' },
      { id: 7, name: 'Quicksand' },
      { id: 8, name: 'Lora' },
      { id: 9, name: 'Raleway' }
    ];
  }
}
